module.exports = __webpack_public_path__ + "63278ea7f2c74b231a9033a418af650f.svg";